export default {
    Reminder: {
        getdata: []
    }
};